import { Box, styled } from '@mui/material'

export const Wrapper = styled(Box)`
  padding: 24px;
`

export const Center = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: ${({ theme }) => theme.palette.text.secondary};
`
